import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-8">Adatvédelmi Nyilatkozat</h1>
        
        <div className="prose prose-lg max-w-none text-gray-700 space-y-6">
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Adatkezelő adatai</h2>
            <p>
              <strong>Név:</strong> XL Bútor és Szőnyeg<br/>
              <strong>Székhely:</strong> 4600 Kisvárda, Attila u. 61.<br/>
              <strong>E-mail:</strong> xlbutorbolt@gmail.com<br/>
              <strong>Telefon:</strong> 06 (70) 417 9210
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Kezelt személyes adatok</h2>
            <p>Weboldalunkon a következő személyes adatokat kezeljük:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Név és elérhetőségi adatok (e-mail cím, telefonszám)</li>
              <li>Számlázási és szállítási címek</li>
              <li>Rendelési információk és előzmények</li>
              <li>Weboldal látogatási adatok (cookies, IP-cím)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Adatkezelés célja és jogalapja</h2>
            <p>Adatkezelésünk céljai és jogalapjai:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Rendelés teljesítése:</strong> szerződés teljesítése (GDPR 6. cikk (1) bekezdés b) pont)</li>
              <li><strong>Számlázás:</strong> könyvviteli kötelezettség teljesítése (GDPR 6. cikk (1) bekezdés c) pont)</li>
              <li><strong>Marketing kommunikáció:</strong> hozzájárulás alapján (GDPR 6. cikk (1) bekezdés a) pont)</li>
              <li><strong>Weboldal működtetése:</strong> jogos érdek (GDPR 6. cikk (1) bekezdés f) pont)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Adatok tárolási ideje</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Rendelési adatok:</strong> 8 év (könyvviteli kötelezettség)</li>
              <li><strong>Marketing adatok:</strong> hozzájárulás visszavonásáig</li>
              <li><strong>Weboldal látogatási adatok:</strong> 2 év</li>
              <li><strong>Cookie-k:</strong> a cookie típusától függően (lásd: Cookie szabályzat)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Adatok továbbítása</h2>
            <p>Személyes adatait csak a szolgáltatásunk teljesítéséhez szükséges harmadik feleknek adjuk át:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Futárszolgálatok (csomagküldéshez)</li>
              <li>Fizetési szolgáltatók (fizetés feldolgozásához)</li>
              <li>Könyvelő iroda (könyvviteli feladatokhoz)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Érintett jogai</h2>
            <p>GDPR szerint a következő jogokkal rendelkezik:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Hozzáférési jog:</strong> adatai kezeléséről tájékoztatást kérhet</li>
              <li><strong>Helyesbítési jog:</strong> hibás adatok javítását kérheti</li>
              <li><strong>Törlési jog:</strong> adatai törlését kérheti bizonyos esetekben</li>
              <li><strong>Korlátozási jog:</strong> adatkezelés korlátozását kérheti</li>
              <li><strong>Adathordozhatósági jog:</strong> adatai másolását kérheti</li>
              <li><strong>Kifogásolási jog:</strong> adatkezelés ellen kifogást tehet</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Jogérvényesítés</h2>
            <p>
              Jogai érvényesítéséhez forduljon hozzánk az xlbutorbolt@gmail.com e-mail címen, 
              vagy írjon a 4600 Kisvárda, Attila u. 61. címre.
            </p>
            <p className="mt-4">
              Panaszt a Nemzeti Adatvédelmi és Információszabadság Hatósághoz (NAIH) 
              tehet: 1055 Budapest, Falk Miksa utca 9-11., vagy www.naih.hu weboldalon.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Adatvédelmi nyilatkozat módosítása</h2>
            <p>
              Jogfenntartjuk magunknak a jogot, hogy ezt az adatvédelmi nyilatkozatot 
              bármikor módosítsuk. A módosításokról a weboldalunkon keresztül tájékoztatjuk.
            </p>
          </section>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-500">
              <strong>Utolsó módosítás:</strong> 2024. december
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
